import common from '@metarhia/common';

const waitPageLoad = (): Promise<unknown> =>
  new Promise(resolve => {
    window.addEventListener('load', resolve);
  });

const ensureSwSupport = (fn: () => Promise<any>) => (): Promise<any> => {
  if ('serviceWorker' in navigator) {
    return fn();
  } else {
    // Return a pending promise instead of Promise.resolve() so that it's safe
    // to assume the browser supports service workers in follow-up then clauses.
    return new Promise(common.emptiness);
  }
};

export const register = ensureSwSupport(() =>
  waitPageLoad().then(() =>
    navigator.serviceWorker.register('/service-worker.js')
  )
);

export const unregister = ensureSwSupport(() =>
  navigator.serviceWorker
    .getRegistrations()
    .then(registrations =>
      registrations.map(registration => registration.unregister())
    )
    .then(Promise.all)
);
